import React, { useState, useEffect } from "react";
import { fetchTotalUnverifiedCars } from "../../stores/api_calls/dashboard";
import { GoUnverified } from "react-icons/go";
import { AiOutlineArrowRight } from "react-icons/ai";
import "./card.scss";
import { useNavigate } from "react-router-dom";

const UnverifiedCars = () => {
  const navigate = useNavigate();
  const [unverifiedUsedCars, setUnverifiedUsedCars] = useState();
  const [unverifiedNewCars, setUnverifiedNewCars] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    const getUnVerifiedUsedCars = fetchTotalUnverifiedCars("Used");

    getUnVerifiedUsedCars
      .then((res) => {
        if (res.data) {
          if (res.data.success) {
            // console.log(res.data);
            setUnverifiedUsedCars(res.data.data);
            setIsLoading(false);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    setIsLoading(true);

    const getUnVerifiedNewCars = fetchTotalUnverifiedCars("New");

    getUnVerifiedNewCars
      .then((res) => {
        if (res.data) {
          if (res.data.success) {
            setUnverifiedNewCars(res.data.data);
            setIsLoading(false);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <div>
      <div className="unverified header-card">
        <p className="header-text">
          Unverified <br /> Bikes
        </p>
        <GoUnverified />
      </div>
      <div className="unverified body-card">
        <p className="verified-text">
          <span
            style={{ cursor: "pointer" }}
            onClick={() => navigate("../bikes/unverified", { replace: true })}
          >
            Used :{" "}
            {isLoading
              ? "fetching"
              : !isLoading && unverifiedUsedCars
              ? unverifiedUsedCars.total_unverified
              : null}
          </span>
          &nbsp; &nbsp;
          <span
            style={{ cursor: "pointer" }}
            onClick={() => navigate("../bikes/unverified-new", { replace: true })}
          >
            New :{" "}
            {isLoading
              ? "fetching"
              : !isLoading && unverifiedNewCars
              ? unverifiedNewCars.total_unverified
              : null}
          </span>
        </p>
        
      </div>
    </div>
  );
};

export default UnverifiedCars;
